export default function StatsSection() {
  const stats = [
    { value: "1,000万+", label: "原创资源总量", icon: "ri-database-2-line" },
    { value: "5,000+", label: "认证创作者", icon: "ri-user-star-line" },
    { value: "200万+", label: "服务企业客户", icon: "ri-building-4-line" },
    { value: "99.8%", label: "版权合规率", icon: "ri-shield-check-line" },
  ];

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100 rounded-2xl">
      <div className="text-center mb-10">
        <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-2">平台实力</h2>
        <p className="text-foreground-600 text-sm">数字见证，品质可信</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {stats.map((stat, i) => (
          <div key={i} className="text-center p-4">
            <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-100">
              <i className={`${stat.icon} text-primary-500 text-lg`}></i>
            </div>
            <div className="font-heading text-2xl md:text-3xl font-bold text-primary-500 mb-1">{stat.value}</div>
            <div className="text-foreground-600 text-xs">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}